@if (isOpen) {
<div class="modal-overlay" role="dialog" aria-modal="true" (click)="onClose()">
  <div class="user-profile-card" (click)="$event.stopPropagation()">
    <div class="modal-content">

      <header class="modal-header">
        <div>
          <h4 class="modal-title">Perfil do Usuário</h4>
          <span class="system-badge">KALI ERP</span>
        </div>
        <button type="button" class="btn-close" (click)="onClose()" aria-label="Fechar"></button>
      </header>

      <div class="modal-body">

        <!-- Perfil: avatar + nome lado a lado -->
        <div class="profile-header">
          <div class="avatar-container">
            <img src="/assets/icons/no-user-transparent.png"
                 alt="Avatar"
                 class="profile-img"
                 onerror="this.src='assets/icons/default-avatar.png'">
          </div>
          <div class="profile-main-info">
            <span class="profile-name">{{ nomeExibicao }}</span>
            <span class="profile-role">{{ perfilUsuario }}</span>
          </div>
        </div>

        <hr class="divider">

        <!-- Info em 2 colunas -->
        <div class="info-grid">
          <div class="info-item">
            <label>Username</label>
            <span class="info-value">{{ username }}</span>
          </div>
          @if (tenant) {
            <div class="info-item">
              <label>Empresa</label>
              <span class="info-value" data-testid="sessao-tenant">{{ tenant }}</span>
            </div>
          }
          <div class="info-item">
            <label>E-mail</label>
            <span class="info-value">{{ email }}</span>
          </div>
          <div class="info-item col-span-2">
            <label>Último Acesso</label>
            <span class="info-value">{{ ultimoAcesso | date:'dd/MM/yyyy - HH:mm' }}</span>
          </div>
          <div class="info-item col-span-2">
            <label>Rastreamento GPS</label>
            <span class="info-value gps-value"
                  [class.gps-ativo]="gpsStatus === 'ativo'"
                  [class.gps-inativo]="gpsStatus === 'inativo'">
              <span class="gps-icon" aria-hidden="true">
                {{ gpsStatus === 'verificando' ? '⏳' : (gpsStatus === 'ativo' ? '📍' : '🚫') }}
              </span>
              {{ gpsStatus === 'verificando' ? 'Verificando...' : (gpsStatus === 'ativo' ? 'Ativo' : 'Inativo') }}
            </span>
          </div>
        </div>

        <hr class="divider">

        <!-- Bloco de ambiente: farois + versões -->
        <div class="sistema-card">
          <p class="sistema-card-title">Ambiente</p>

          @if (isLoadingStatus) {
            <div class="sistema-loading">
              <span class="spinner-border spinner-border-sm text-secondary me-2"></span>
              <span>Verificando conexão...</span>
            </div>
          }

          @if (!isLoadingStatus && serverStatus) {
            <div class="farois-row">
              <div class="farol-item">
                <span class="status-dot"
                  [class.up]="serverStatus.status === 'UP'"
                  [class.down]="serverStatus.status !== 'UP'">
                </span>
                <span class="farol-label">Servidor</span>
                <span class="farol-status"
                  [class.text-up]="serverStatus.status === 'UP'"
                  [class.text-down]="serverStatus.status !== 'UP'">
                  {{ serverStatus.status }}
                </span>
              </div>

              <div class="farol-divider"></div>

              <div class="farol-item">
                <span class="status-dot"
                  [class.up]="serverStatus.bancoDados === 'UP'"
                  [class.down]="serverStatus.bancoDados !== 'UP'">
                </span>
                <span class="farol-label">Banco de Dados</span>
                <span class="farol-status"
                  [class.text-up]="serverStatus.bancoDados === 'UP'"
                  [class.text-down]="serverStatus.bancoDados !== 'UP'">
                  {{ serverStatus.bancoDados }}
                </span>
              </div>
            </div>

            <div class="versoes-row">
              <div class="versao-item">
                <span class="versao-label">Servidor</span>
                <span class="versao-value">v{{ serverStatus.versao }}</span>
              </div>
              <div class="versao-item">
                <span class="versao-label">Cliente</span>
                <span class="versao-value">v{{ clientVersion }}</span>
              </div>
              <div class="versao-item">
                <span class="versao-label">Perfil</span>
                <span class="versao-value">{{ serverStatus.perfil }}</span>
              </div>
            </div>
          }

          @if (!isLoadingStatus && hasStatusError) {
            <div class="farois-row">
              <div class="farol-item">
                <span class="status-dot down"></span>
                <span class="farol-label">Servidor</span>
                <span class="farol-status text-down">Inacessível</span>
              </div>
              <div class="farol-divider"></div>
              <div class="farol-item">
                <span class="status-dot down"></span>
                <span class="farol-label">Banco de Dados</span>
                <span class="farol-status text-down">—</span>
              </div>
            </div>
            <div class="versoes-row">
              <div class="versao-item">
                <span class="versao-label">Servidor</span>
                <span class="versao-value" style="color:#dc2626">—</span>
              </div>
              <div class="versao-item">
                <span class="versao-label">Cliente</span>
                <span class="versao-value">v{{ clientVersion }}</span>
              </div>
              <div class="versao-item">
                <span class="versao-label">Perfil</span>
                <span class="versao-value" style="color:#dc2626">—</span>
              </div>
            </div>
          }
        </div>
      </div>

      <footer class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="atualizarCadastro()">
          Atualizar Cadastro
        </button>
        <button type="button" class="btn btn-logout" (click)="logout()">
          Sair do Sistema
        </button>
      </footer>
    </div>
  </div>
</div>
}
